import createImmutableSelector from 'lib/immutable/selector'
import { IBlog } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getBlog = (state: any): IBlog => state.get('blogReducer')

export const blogSelector = createImmutableSelector(getBlog, (blog) => blog)
